/** Portal target so modals escape overflow:hidden table cards and sidebar stacking. */
export const CREDORA_MODAL_CONTAINER =
  typeof document !== "undefined" ? document.body : undefined;

export const CREDORA_MODAL_CLASS = "credora-modal";
